import React from "react";
import testImage1 from "../../assets/image/testIcon.png";
import { baseUrl } from "../../utils/base_url";
import { useMediaQuery } from "react-responsive";
import {
  _1200px,
  _1400px,
  _1600px,
  _1700px,
  _1800px,
  _576px,
  _768px,
  _992px,
} from "../../utils/mediaBreakpoints";

const PrivacyAndGlobalCompliance = ({ data }) => {
  const _576 = useMediaQuery({ maxWidth: _576px });
  const _768 = useMediaQuery({ maxWidth: _768px });
  const _992 = useMediaQuery({ maxWidth: _992px });
  const _1200 = useMediaQuery({ maxWidth: _1200px });
  const _1400 = useMediaQuery({ maxWidth: _1400px });
  const _1600 = useMediaQuery({ maxWidth: _1600px });
  const _1700 = useMediaQuery({ maxWidth: _1700px });
  const _1800 = useMediaQuery({ maxWidth: _1800px });
  return (
    <>
      <div className="row " style={{ backgroundColor: " #090D24" }}>
        <div className="container p-0 contwidth">
          <div
            className="row h-100 gy-5"
            style={{
              padding: _992 ? "4rem 0rem 4rem 0rem" : "9rem 0rem 4rem 0rem",
            }}
          >
            <div className="col-lg-6">
              <div
                className="d-flex flex-column gap-2  h-100"
                style={{ padding: _992 ? "0rem 0rem" : "6rem 0rem" }}
              >
                <p
                  className="text-white fw800 "
                  style={{
                    fontSize: _576
                      ? "30px"
                      : _768
                      ? "30px"
                      : _992
                      ? "40px"
                      : _1200
                      ? "40px"
                      : _1400
                      ? "45px"
                      : _1600
                      ? "50px"
                      : _1700
                      ? "60px"
                      : _1800
                      ? "70px"
                      : "70px",
                    lineHeight: _576
                      ? "2.3rem"
                      : _768
                      ? "2.3rem"
                      : _992
                      ? "2.8rem"
                      : _1200
                      ? "2.8rem"
                      : _1400
                      ? "3rem"
                      : _1600
                      ? "4rem"
                      : _1700
                      ? "4.5rem"
                      : _1800
                      ? "5rem"
                      : "5rem",
                  }}
                >
                  {data?.heading}
                </p>
                <p
                  dangerouslySetInnerHTML={{
                    __html: data?.sub_heading?.split("\n")?.join("<br/>"),
                  }}
                  className="text-white fw400 "
                  style={{
                    color: "#E5E5E5",
                    fontSize: _576
                      ? "16px"
                      : _768
                      ? "18px"
                      : _992
                      ? "24px"
                      : _1200
                      ? "24px"
                      : _1400
                      ? "26px"
                      : _1600
                      ? "30px"
                      : _1700
                      ? "35px"
                      : _1800
                      ? "40px"
                      : "40px",
                    lineHeight: _576
                      ? "1.5rem"
                      : _768
                      ? "1.5rem"
                      : _992
                      ? "1.8rem"
                      : _1200
                      ? "1.9rem"
                      : _1400
                      ? "2.1rem"
                      : _1600
                      ? "2.2rem"
                      : _1700
                      ? "2.5rem"
                      : _1800
                      ? "2.8rem"
                      : "2.8rem",
                  }}
                />
              </div>
            </div>
            <div className="col-lg-6">
              <div className="d-flex flex-column gap-2 px-lg-5">
                {data?.compliances?.map((obj, idx) => (
                  <React.Fragment key={idx}>
                    <Compliance data={obj} />
                  </React.Fragment>
                ))}
              </div>
            </div>

            <div className="col-12">
              <p
                className="fw400 text-center"
                style={{
                  color: "#E5E5E5",
                  fontSize: _576
                    ? "11px"
                    : _768
                    ? "11px"
                    : _992
                    ? "15px"
                    : _1200
                    ? "15px"
                    : _1400
                    ? "17px"
                    : _1600
                    ? "19px"
                    : _1700
                    ? "22px"
                    : _1800
                    ? "26px"
                    : "26px",
                  lineHeight: _576
                    ? "18px"
                    : _768
                    ? "20px"
                    : _992
                    ? "22px"
                    : _1200
                    ? "24px"
                    : _1400
                    ? "26px"
                    : _1600
                    ? "28px"
                    : _1700
                    ? "29px"
                    : _1800
                    ? "30px"
                    : "30px",
                }}
              >
                {data?.description}
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export const Compliance = ({ data }) => {
  const _576 = useMediaQuery({ maxWidth: _576px });
  const _768 = useMediaQuery({ maxWidth: _768px });
  const _992 = useMediaQuery({ maxWidth: _992px });
  const _1200 = useMediaQuery({ maxWidth: _1200px });
  const _1400 = useMediaQuery({ maxWidth: _1400px });
  const _1600 = useMediaQuery({ maxWidth: _1600px });
  const _1700 = useMediaQuery({ maxWidth: _1700px });
  const _1800 = useMediaQuery({ maxWidth: _1800px });

  console.log(data);
  return (
    <>
      <div className="d-flex align-items-center  gap-3">
        <img
          src={`${baseUrl}${data?.image?.url}`}
          alt=""
          width={
            _576
              ? 48
              : _768
              ? 50
              : _992
              ? 50
              : _1200
              ? 54
              : _1400
              ? 60
              : _1600
              ? 64
              : _1700
              ? 68
              : _1800
              ? 74
              : 74
          }
        />

        <div className="d-flex flex-column w-100 gap-2 pt-4">
          <p
            className="fw600 text-white"
            style={{
              fontSize: _576
                ? "14px"
                : _768
                ? "16px"
                : _992
                ? "16px"
                : _1200
                ? "13px"
                : _1400
                ? "16px"
                : _1600
                ? "18px"
                : _1700
                ? "20px"
                : _1800
                ? "22px"
                : "22px",
            }}
          >
            {data?.heading}
          </p>
          <div
            className="w-100"
            style={{ height: "2px", background: data?.borderColor }}
          />
        </div>
      </div>
    </>
  );
};

export default PrivacyAndGlobalCompliance;
